import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import "./global.css"; // Import the global CSS file
import { CssBaseline } from "@mui/material";
import L from "leaflet"; // Import Leaflet and attach it to the global object

import "leaflet/dist/leaflet.css";
import "leaflet-routing-machine";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import 'react-phone-input-2/lib/material.css';
import LoadingPage from "./components/common/LoadingPage";
import { I18nextProvider } from 'react-i18next';
import i18n from './locales/i18n';
import getProjectConfig from "./configs/projectConfigs";
import Metadata from "./components/MetaData";
import { createRoot } from "react-dom/client";

const App = React.lazy(() => import('./App'));

const projectConfig = getProjectConfig();

const metadataProps = {
  title: projectConfig?.title || 'Default App',
  logo: projectConfig?.tabIcon || '/favicon.ico',
  og: projectConfig?.og,
};

window.L = L;

const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <Metadata {...metadataProps} />
    <CssBaseline />
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<LoadingPage />}>
        <App />
      </Suspense>
    </I18nextProvider>
  </Provider>
);

reportWebVitals();
